import React, { useEffect, useRef } from 'react';

import {
  DashboardType,
  emailLinkedPaths,
  getInitialLandingURL,
  getPharmacistWorkshiftStatus,
  PharmacistLegendVariant,
  pharmacistResetValue,
  professionalWorkshiftStatus,
  setActiveDashboard,
  utilResetValue,
} from '@pharmaplan/common';
import LogoutHandler from '@pharmaplan/common/helpers/LogoutHandler';

import PharmacyPostedList from '../components/Modals/WorkshiftDetails/PharmacyPostedList';
import { allowedPaths, ScreenTypes } from '../helpers/Constants';
import { renderScreen, setOpen } from '../actions/drawerActions';
import { setDialog } from '../reducers/dialogReducer';

import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import useProfessional from './Professional/useProfessional';

const useHandleLandingUrls = () => {
  const dispatch = useAppDispatch();
  const landingUrl = useAppSelector(getInitialLandingURL);
  const { isProfessional } = useProfessional();
  const isUserLoggedIn = LogoutHandler.isUserLoggedIn();
  const workshiftStatus = useAppSelector(professionalWorkshiftStatus);
  const externalRef = useRef(false);

  const url = new URL(globalThis.location.href);
  const { pathname } = url ?? {};

  let parsedLandingURL = null;

  if (landingUrl) {
    parsedLandingURL = new URL(landingUrl);
  }

  const openDrawer = (type: PharmacistLegendVariant, id: string) => {
    dispatch(setOpen(true));
    dispatch(
      renderScreen({
        screenType: ScreenTypes.serviceWorkshiftDetails,
        screenNumber: 1,
        eventIds: [id ?? ''],
        type,
        extraParameters: {
          isAutoSyncIDMap: { [id]: externalRef.current },
        },
      }),
    );
    externalRef.current = false;
    dispatch(utilResetValue(['initialLandingURL']));
  };

  const handleWorkshiftDetails = (id: string | null) => {
    if (id) {
      dispatch(
        getPharmacistWorkshiftStatus({
          id: id ?? '',
          isExternal: externalRef.current,
        }),
      );
    }
  };

  const handleViewMore = (id: string | null) => {
    if (id) {
      dispatch(
        setDialog({
          Component: <PharmacyPostedList id={id} />,
          heading: {
            title: '',
          },
          showCloseButton: false,
          maxWidth: 'md',
        }),
      );
      dispatch(utilResetValue(['initialLandingURL']));
    }
  };

  const handlers = {
    [emailLinkedPaths.workshiftDetails]: handleWorkshiftDetails,
    [emailLinkedPaths.viewMoreShift]: handleViewMore,
  };

  useEffect(() => {
    if (
      isUserLoggedIn
      && isProfessional
      && ((parsedLandingURL?.pathname
        && allowedPaths.has(parsedLandingURL?.pathname))
        || allowedPaths.has(pathname))
    ) {
      const id = parsedLandingURL?.searchParams.get('id') ?? url?.searchParams.get('id');
      const isExternal = parsedLandingURL?.searchParams.get('isExternal') ?? url?.searchParams.get('isExternal');
      externalRef.current = isExternal === 'true';

      handlers[parsedLandingURL?.pathname ?? pathname]?.(id);
      dispatch(setActiveDashboard(DashboardType.calendar));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [landingUrl, isUserLoggedIn]);

  useEffect(() => {
    if (workshiftStatus?.workshiftId) {
      const { bookingId, workshiftId, type } = workshiftStatus ?? {};
      dispatch(pharmacistResetValue(['workshiftStatus']));
      openDrawer(type, bookingId || workshiftId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workshiftStatus?.workshiftId]);
};

export default useHandleLandingUrls;
